__turbopack_context__.v({
  "body": "J2NOgW_body",
  "filmCard": "J2NOgW_filmCard",
  "filmLayer": "J2NOgW_filmLayer",
  "filmVideoFill": "J2NOgW_filmVideoFill",
  "intro": "J2NOgW_intro",
  "outer": "J2NOgW_outer",
  "stage": "J2NOgW_stage",
  "title": "J2NOgW_title",
});
